<div class="application-developer" [ngClass]="{ 'application-developer-100' : modalDialogComponent?.status }">
  <div *ngIf="displayWarning" class="warnings">
    <p class="text-xs overwrite-warning"
    >{{ 'program.pre-qualification.form-overwrite-warning' | translate }}</p>
    <ng-container *ngIf="isDirty()">
      <p class="text-xs saving-guard"
      >{{ 'program.pre-qualification.claims-reporting.saving-guard' | translate }}</p>
    </ng-container>
  </div>
  <div class="form-header">
    <div class="stage-info">
      <h3>{{ stageConfigName }}</h3>
      <i *ngIf="subHeading">{{ subHeading }}</i>
      <p *ngIf="currentStatusSubmitted">
        {{ 'program.pre-qualification.application-submitted' | translate }}: {{ programApplication?.submitDateTime }}
      </p>
    </div>
    <div class="form-buttons-container form-buttons-container-top">
      <ng-container *ngIf="!currentStatusSubmitted">
        <button class="btn btn-primary-light" (click)="triggerSave()">
          {{'buttons.save' | translate}}
        </button>
        <button
          class="btn btn-primary"
          (click)="beforeSubmit()"
          [disabled]="!formValid || readOnly">
          {{'buttons.submit-application' | translate}}
        </button>
      </ng-container>
    </div>
  </div>
  <div class="pre-qualification">
    <tabset class="plain-tabs">
      <tab heading="{{'program.pre-qualification.application.form' | translate}}"
          (selectTab)="tabs.form = true"
          (deselect)="tabs.form = false">
        <ng-container *ngIf="tabs.form">
          <ng-container *ngIf="loadingForm; else FormLoaded">
            {{ 'program.pre-qualification.loading' | translate }}
          </ng-container>
          <ng-template #FormLoaded>
            <ng-container *ngIf="json; else noData">
              <oes-dynamic-form
                class="dynamic-form"
                [json]="json"
                [readOnly]="readOnly"
                (beforeSubmission)="beforeSubmit($event)"
                (changed)="formChanged($event)"
                [enableSubmit]="!currentStatusSubmitted"
                (formValid)="formValid = $event"
                (save)="formSave($event)"
                #oesDynamicForm>
              </oes-dynamic-form>
            </ng-container>
            <ng-template #noData>
              <div class="empty-outer">
                <div class="empty">
                  <oes-notify
                    [iconName]="'fa-exclamation'"
                    [message]="'program.pre-qualification.no-form' | translate"
                    [type]="'empty'">
                  </oes-notify>
                </div>
              </div>
            </ng-template>
          </ng-template>
        </ng-container>
      </tab>

      <!-- attachments -->
      <tab heading="{{ 'program.pre-qualification.application.attachments' | translate }}"
          (selectTab)="tabs.attachments = true"
          (deselect)="tabs.attachments = false">
        <oes-files
          *ngIf="tagTypes && tabs.attachments"
          [storageKey]="'application'"
          [tagTypes]="tagTypes"
          [title]="'program.pre-qualification.application-files' | translate"
          [uploadExtraMessage]="'program.pre-qualification.upload-warning' | translate"
          [accessControl]="accessControl"
          [removeHeight]="'400px'">
        </oes-files>
      </tab>
    </tabset>
  </div>
  <div class="form-buttons-container bottom">
    <ng-container *ngIf="!currentStatusSubmitted">
      <button class="btn btn-primary-light" (click)="triggerSave()">
        {{'buttons.save' | translate}}
      </button>
      <button
        class="btn btn-primary"
        (click)="beforeSubmit()"
        [disabled]="!formValid || readOnly">
        {{'buttons.submit-application' | translate}}
      </button>
    </ng-container>
  </div>

  <!-- submit confirmation dialog -->
  <oes-modal-dialog
    [title]="'program.pre-qualification.submit-responses' | translate"
    (submit)="submitProgramApplication()">
    <!-- the below goes to dialog-body -->
    <div>{{ 'program.pre-qualification.ready' | translate }}</div>
  </oes-modal-dialog>
</div>